import { generateUuid } from "@/utils/uuid";

let uniqueTabId: string | null = null;

/**
 * Genereert en retourneert een unieke tab-ID.
 * De ID wordt gegenereerd bij de eerste aanroep en blijft hetzelfde gedurende de levensduur van de tab.
 */
export function getUniqueTabId(): string {
  if (!uniqueTabId) {
    uniqueTabId = generateUuid();
  }

  return uniqueTabId;
}
